import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A gizmo that fills a box: an AABB as a translucent unlit mesh, the way Godot's `add_solid_box`
 * draws it. Godot adds it only to a selected gizmo, so the caller draws it for the selected state alone.
 */
import { useMemo } from 'react';
import * as THREE from 'three';
import { aabbCenter } from '../../godot/math/aabb';
import { allFinite } from '../../godot/variant/number';
import { useGodotLinearColor } from '../godotColor';
import { GizmoMesh } from './GizmoMesh';
function solidBoxGeometry(aabb) {
    const { size } = aabb;
    const centre = aabbCenter(aabb);
    return new THREE.BoxGeometry(size.x, size.y, size.z).translate(centre.x, centre.y, centre.z);
}
/** Draws nothing for a box with an `inf` or `nan` size or position, which three cannot bound. */
function isFiniteBox({ position, size }) {
    return allFinite([position.x, position.y, position.z, size.x, size.y, size.z]);
}
export function AabbSolidGizmo({ aabb, color, alpha }) {
    const geometry = useMemo(() => (isFiniteBox(aabb) ? solidBoxGeometry(aabb) : null), [aabb]);
    return _jsx(GizmoMesh, { geometry: geometry, color: useGodotLinearColor(color), alpha: alpha });
}
//# sourceMappingURL=AabbSolidGizmo.js.map